<template>
    <div :class="['report-sidebar', 'common-nav-wrap', { collapsed }]">
        <Simplebar class="with-border-track">
            <div class="common-nav">
                <div class="list-types-reports">
                    <Sidebar
                        :parent-name="ROUTE_NAMES.REPORTS"
                        :list="reportsList"
                        :current-id="id"
                        :search="false"
                        :report-mode="reportMode"
                    />
                </div>
                <div class="custom-reports">
                    <template v-if="customReportsList.length > 0">
                        <p class="custom-reports-title">{{ $t('reports.customReports') }}</p>
                        <Sidebar
                            :parent-name="ROUTE_NAMES.REPORTS__CUSTOM"
                            :list="customReportsList"
                            :current-id="id"
                            :search-placeholder="$t('common.searchPlaceholder')"
                            :is-active-icon-shown="isScheduled"
                            :active-icon="'icon-time'"
                            :report-mode="reportMode"
                            :collapsed="collapsed"
                            :show-icons="showIcons"
                            @delete="removeEntry"
                        />
                    </template>
                    <p v-else class="custom-reports-title">{{ $t('reports.noCustomReports') }}</p>
                </div>
                <div v-if="collapsed" class="report-sidebar-icon-wrap">
                    <i class="icon-chewron-down"></i><span>{{ $t('reports.title') }}</span>
                </div>
            </div>
        </Simplebar>
    </div>
</template>

<script type="text/babel">
import Sidebar from '../common/Sidebar.vue';
import Simplebar from 'simplebar-vue';
import { ROUTE_NAMES } from '../../constants';

export default {
    components: {
        Sidebar,
        Simplebar,
    },

    constants: {
        ROUTE_NAMES: ROUTE_NAMES,
    },

    props: {
        id: {
            type: Number,
            required: true,
        },

        collapsed: {
            type: Boolean,
            required: true,
        },

        reportsList: {
            type: Array,
            required: true,
        },

        customReportsList: {
            type: Array,
            required: true,
        },

        removeEntry: {
            type: Function,
            default: () => {},
            required: false,
        },

        reportMode: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            showIcons: this.customReportsList.some(report => {
                return this.isScheduled(report);
            }),
        };
    },

    methods: {
        isScheduled(schedule) {
            return !!schedule.schedule_type;
        },
    },
};
</script>
